const accordionMapping = (data) => {
  const mappedData = {};

  mappedData.accordionBody = data.field_component_body[0]?.value || '';
  mappedData.accordionOpenCTA = data.field_accordion_open_cta[0] ? {
    title: data.field_accordion_open_cta[0].title || '',
    alt: data.field_accordion_open_cta[0].options
      .attributes['aria-label'] || '',
    ariaLabel: data.field_accordion_open_cta[0].options
      .attributes['aria-label'] || '',
  } : {};

  mappedData.accordionCloseCTA = data.field_accordion_close_cta[0] ? {
    title: data.field_accordion_close_cta[0].title || '',
    alt: data.field_accordion_close_cta[0].options
      .attributes['aria-label'] || '',
    ariaLabel: data.field_accordion_close_cta[0].options
      .attributes['aria-label'] || '',
  } : {};

  mappedData.accordionBackToTopCTA = data.field_accordion_back_cta[0] ? {
    title: data.field_accordion_back_cta[0].title || '',
    alt: data.field_accordion_back_cta[0].options
      .attributes['aria-label'] || '',
    ariaLabel: data.field_accordion_back_cta[0].options
      .attributes['aria-label'] || '',
  } : {};

  return mappedData;
}

export default accordionMapping;
